<template>
    <div class="container">
       <Row>
        <Col span="24" offset="0" align="left">
        <Breadcrumb separator=">">
          <BreadcrumbItem ><router-link  :to="{ path: '/content' }">首页</router-link></BreadcrumbItem>
          <BreadcrumbItem > <router-link  :to="{ path: '/show' }">公告</router-link></BreadcrumbItem>
        </Breadcrumb>
        <hr style="color: gainsboro">
        </Col>
      </Row>
      <Row>
        <Col span="24" offset="0" class="yangshi">
        <Row>
          <br>
          <Col span="24" offset="0" style="font-size: 24px;line-height:25px;">
           {{notice.noticeTitle}}
          </Col>
          <Col span="3" offset="21"> 
	        <div> 
          <template> {{notice.publishDate}}</template></div>
           </Col>
           <Col span="24" offset="0" >
           <hr>
           </Col>
        <!--<Row v-for="(item,index) in datas" :key="index">noticeContent-->
           <Row>
              <Col span="21" offset="2" align="left" style="font-size: 17px;"><div v-html="content"></div></Col>
           </Row>
       <!-- </Row>-->
        </Row>
        </Col>
      </Row>
      <br> 
        </Col>
      </Row>
    </div>
</template>

<script>
    export default {
        name: "index",
        data(){
          return{
            notice:[],
            content:'',
             icon:1
            }
          },
          mounted(){
            this.getNotice();
          },
          methods:{
            getNotice:function(){
                let noticeId = this.$route.query.detailId;
                protocol.param_contentDetail.data = {};
                protocol.param_contentDetail.data.id= noticeId;    
                http.gets(protocol.param_contentDetail,protocol.param_contentDetail.data).then(response => {
                let {id,title,publishDate,txt} = response.data;
                    if (id!=null || id!="") {
                        if(title!=null ){
                          this.notice.noticeTitle=title;
                        }
                        if(publishDate!=null ){
                          this.notice.publishDate=publishDate;
                        }
                        if(txt!=null ){
                          this.content=txt;
                        }
                      }
                    else{
                      this.notice = [];
                      this.content= '';
                    }
              });
            }
          }
        }
</script>

<style scoped>
  .container{
    margin: 0 auto;
    height: auto;
    background: whitesmoke;
    width: 100%;

  }
  .yangshi{
    background: white;
    min-height: 250px;
    box-shadow: 0.5px 0.5px 3px 0.5px darkgray;display: block
  }
  ul{
    text-align:left;
  }
  li{
    height:50px;
  }
   table {
    border-collapse: collapse;
    cursor: pointer;
    width: 90%;
    margin: 10px auto;
  }
  td{
    border: 1px solid lightgray;
    height: 50px;
    width:100px;
  }
  tr{ border: 1px solid lightgray}
  tr:hover{
    background: whitesmoke;
  }
  td:nth-child(2n-1){
    background:#F5F5F5;
  }
</style>



// WEBPACK FOOTER //
// src/views/show/components/index.vue